import React, { useState } from "react";
import axios from "axios";
import { FormControl, TextField } from "@material-ui/core";
import { Alert, Autocomplete } from "@material-ui/lab";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialDialog from "../../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../styles/styledDialog";

const MANAGER_TYPES = ["cash", "bank", "crypto"];
const EMPTY_FORM    = { projectId: "", type: "crypto", walletAddress: "", label: "" };

const TelegramAddDrainWalletDialog = ({ setNotification, onAdded, t }) => {
  const [open, setOpen]       = useState(false);
  const [form, setForm]       = useState(EMPTY_FORM);
  const [projects, setProjects] = useState([]);

  const handleOpen = () => {
    setForm(EMPTY_FORM);
    setProjects([]);
    setOpen(true);
    axios.get("/api/projects?itemsPerPage=200", userAuthenticationConfig())
      .then(r => setProjects(r.data["hydra:member"] || []))
      .catch(() => {});
  };

  const handleAdd = () => {
    if (!form.projectId) {
      setNotification({ visible: true, type: "error", message: t("drainWallets.errors.projectRequired") });
      return;
    }
    if (!form.walletAddress.trim() || !form.label.trim()) {
      setNotification({ visible: true, type: "error", message: t("drainWallets.errors.addressLabelRequired") });
      return;
    }
    axios.post(
      `/api/telegram/projects/${form.projectId}/drain-wallets`,
      { type: form.type, walletAddress: form.walletAddress.trim(), label: form.label.trim() },
      userAuthenticationConfig()
    ).then(response => {
      if (response.status === 201) {
        setOpen(false);
        setNotification({ visible: true, type: "success", message: t("drainWallets.success.added") });
        onAdded();
      }
    }).catch(error => {
      setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("drainWallets.errors.add") });
    });
  };

  return (
    <>
      <DefaultButton color="success" onClick={handleOpen}>
        {t("drainWallets.add")}
      </DefaultButton>

      <MaterialDialog open={open}>
        <StyledDialogWrapper>
          <StyledDialogHead>
            {t("drainWallets.dialog.addTitle")}
          </StyledDialogHead>
          <StyledDialogContent>
            <FormControl fullWidth>
              <Autocomplete
                options={projects}
                value={projects.find(p => String(p.id) === form.projectId) || null}
                onChange={(event, project) => setForm(f => ({ ...f, projectId: project ? String(project.id) : "" }))}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label={t("drainWallets.dialog.project")} />
                )}
                blurOnSelect
                disableClearable
              />
            </FormControl>
            <FormControl fullWidth>
              <Autocomplete
                options={MANAGER_TYPES}
                value={form.type}
                onChange={(event, type) => setForm(f => ({ ...f, type: type || "crypto" }))}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField {...params} label={t("drainWallets.dialog.managerType")} />
                )}
                blurOnSelect
                disableClearable
              />
            </FormControl>
            <Alert severity="info">
              <p>USDT TRC20 — {t("drainWallets.dialog.networkNote")}</p>
            </Alert>
            <TextField
              label={t("drainWallets.dialog.label")}
              value={form.label}
              onChange={e => { const v = e.target.value; setForm(f => ({ ...f, label: v })); }}
              required
            />
            <TextField
              label={t("drainWallets.dialog.address")}
              value={form.walletAddress}
              onChange={e => { const v = e.target.value; setForm(f => ({ ...f, walletAddress: v })); }}
              required
              inputProps={{ className: "tg-mono" }}
            />
          </StyledDialogContent>
          <StyledDialogAction col="2">
            <DefaultButton onClick={() => setOpen(false)} color="danger">
              {t("drainWallets.dialog.cancel")}
            </DefaultButton>
            <DefaultButton onClick={handleAdd} color="success">
              {t("drainWallets.dialog.add")}
            </DefaultButton>
          </StyledDialogAction>
        </StyledDialogWrapper>
      </MaterialDialog>
    </>
  );
};

export default TelegramAddDrainWalletDialog;